import {UserSetting} from "types/UserSettings";

export const defaultUserSetting: UserSetting = {
  sendNotificationsToEmail: false,
  sendNotificationsToDevice: false,
  enableSoundNotifications: true,
  soundNotificationsVolume: 50,
  language: "en",
}
